module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activityCompletion flexcenter"
  }, [_c('transition', [_c('div', {
    staticClass: "activity flexcenter modal-section"
  }, [_c('div', {
    staticClass: "activityTitle"
  }, [_c('h3', [_vm._v("前のアクティビティをもう一度、始めから順番に行うことをお勧めします。")])]), _vm._v(" "), _c('div', {
    staticClass: "number-list-wrap"
  }, [_c('ul', {
    staticClass: "number-list"
  }, _vm._l((_vm.questionIconList), function(row, rowIndex) {
    return _c('li', [_c('span', {
      staticClass: "num",
      class: row.iconClass
    })])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "activityContent"
  }, [_c('div', {
    staticClass: "activityScore flexcenter"
  }, [_c('div', {
    staticClass: "item align-center"
  }, [_c('div', [_vm._v("正解率")]), _vm._v(" "), _c('div', {
    staticClass: "answerRate textorange"
  }, [_c('span', {
    staticClass: "font60"
  }, [_vm._v(_vm._s(_vm.answerRate))]), _c('span', {
    staticClass: "font30"
  }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('ul', {
    staticClass: "score-list"
  }, [_c('li', {
    staticClass: "flexbetween"
  }, [_c('span', {
    staticClass: "ok align-left"
  }, [_vm._v("正解")]), _c('span', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.ok))])]), _vm._v(" "), _c('li', {
    staticClass: "flexbetween"
  }, [_c('span', {
    staticClass: "ng align-left"
  }, [_vm._v("不正解")]), _c('span', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.ng))])]), _vm._v(" "), _c('li', {
    staticClass: "flexbetween"
  }, [_c('span', {
    staticClass: "skip align-left"
  }, [_vm._v("スキップ")]), _c('span', {
    staticClass: "align-right"
  }, [_vm._v(_vm._s(_vm.skip))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "activityFooter"
  }, [_c('div', {
    staticClass: "buttons flexbetween"
  }, [_c('div', {
    staticClass: "buttons-top"
  }, [_c('button', {
    staticClass: "retry",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clickButton('repeatSection')
      }
    }
  }, [_vm._v("前のセクションを繰り返す")])]), _vm._v(" "), _c('button', {
    staticClass: "home",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clickButton('home')
      }
    }
  }, [_vm._v("ホーム")]), _vm._v(" "), _c('button', {
    staticClass: "continue",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clickButton('nextSection')
      }
    }
  }, [_vm._v("次のセクションに進む")])])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-90f80474", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-90f80474","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionDialog.vue
// module id = 880
// module chunks = 1